import { useDriverStore } from '@store/driverInfoStore';
import { usePolicyStore } from '@store/policyStore';
import moment from 'moment';
import {postMarketingCloud} from "@api/postMarketingCloud";
import {useTokenStore} from "@store/TokenStore";
import { useCarStore } from '@store/carInfoStore';
export const useSendContacts = () => {
  const { driver } = useDriverStore();
  const { policy } = usePolicyStore();
  const { token } = useTokenStore();
  const { car: carData } = useCarStore();
  let fecha_lead = moment().format('YYYY-MM-DD, hh:mm:ss'); // Date now
  const postSendContacts = async () => {

    try {
      let params = {
        ContactKey: policy.uuid,
        EventDefinitionKey: 'APIEvent-b5773015-62e8-22fc-22e8-f49410b37ec2',
        Data: {
          SubscriberKey: policy.uuid,
          uuid: policy.uuid,
          nombre: driver.name,
          correo: driver.email,
          telefono: driver.telefono,
          fecha_lead: fecha_lead,
          marca: carData.assembler,
          modelo: carData.model
        },
      };
      let response = await postMarketingCloud(token, params);
      console.log("response-Marketing:",response)
    }catch (e){
      console.error("error",e)
    }
  };
  return { postSendContacts };
};
